export default "__VITE_PUBLIC_ASSET__80487707__"